import { BrowserModule } from "@angular/platform-browser";
import {NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler} from '@angular/core';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FormsModule } from "@angular/forms";

import { FeaturesModule } from "@features/features.module";
import { SharedModule } from "@shared/shared.module";
import { CoreModule } from "./core/core.module";

import {
  APP_BASE_HREF,
  LocationStrategy,
  HashLocationStrategy,
} from "@angular/common";
import { MatPaginatorModule } from "@angular/material";
import { MatTableModule } from "@angular/material/table";
import { MatListModule } from "@angular/material/list";
import { MatButtonModule } from "@angular/material/button";
import { AuthenticationModule } from "@core/authentication/authentication.module";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { MsalInterceptor } from "@azure/msal-angular";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {MyMonitoringService} from './logging.service';
import {ErrorHandlerService} from './logging.errors.service';
import {environment} from '@environments/environment';
import { Utilitarios } from "./utils/utilitarios";

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: environment.instrumentationKey
  }
});
appInsights.loadAppInsights();
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    FeaturesModule,
    CoreModule,
    FormsModule,
    MatTableModule,
    MatListModule,
    MatButtonModule,
    MatPaginatorModule,
    AuthenticationModule,
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: "" },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MyMonitoringService,
    Utilitarios,
    { provide: ErrorHandler, useClass: ErrorHandlerService }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
